import { useCallback, useEffect, useState } from 'react';

const SIZE_THRESHOLD_PX = 160;

/**
 * Heuristic devtools detection for auth pages. Not security — trivially bypassed —
 * but matches the light friction some login pages use against casual inspection.
 *
 * Methods: window dimension gap (dock undocked), debugger pause timing.
 * False positives: browser toolbars, small windows, some mobile layouts.
 */
export function useDevtoolsOpen(enabled) {
  const [open, setOpen] = useState(false);

  const check = useCallback(() => {
    if (!enabled) {
      setOpen(false);
      return;
    }

    const widthGap = window.outerWidth - window.innerWidth > SIZE_THRESHOLD_PX;
    const heightGap = window.outerHeight - window.innerHeight > SIZE_THRESHOLD_PX;
    let debuggerPause = false;
    try {
      const start = performance.now();
      // eslint-disable-next-line no-debugger
      debugger;
      debuggerPause = performance.now() - start > 100;
    } catch {
      // ignore
    }

    setOpen(widthGap || heightGap || debuggerPause);
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    check();
    const intervalId = window.setInterval(check, 800);
    window.addEventListener('resize', check);

    const blockShortcuts = (event) => {
      if (event.key === 'F12') {
        event.preventDefault();
        check();
        return;
      }
      if (event.ctrlKey && event.shiftKey) {
        const key = event.key.toLowerCase();
        if (key === 'i' || key === 'j' || key === 'c') {
          event.preventDefault();
          check();
        }
      }
    };

    document.addEventListener('keydown', blockShortcuts);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener('resize', check);
      document.removeEventListener('keydown', blockShortcuts);
    };
  }, [enabled, check]);

  return open;
}
